module.exports = __webpack_public_path__ + "static/media/building-image-1.cbc6639c.jpg";